/* eslint-disable no-unused-vars */
export enum TextAlignments {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
